import { render } from "./BlockAnalytics.vue?vue&type=template&id=9e6674e6&scoped=true"
import script from "./BlockAnalytics.vue?vue&type=script&lang=js"
export * from "./BlockAnalytics.vue?vue&type=script&lang=js"

import "./BlockAnalytics.vue?vue&type=style&index=0&id=9e6674e6&scoped=true&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9e6674e6"],['__file',"resources/js/components/analytics/BlockAnalytics.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9e6674e6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9e6674e6', __exports__)) {
    api.reload('9e6674e6', __exports__)
  }
  
  module.hot.accept("./BlockAnalytics.vue?vue&type=template&id=9e6674e6&scoped=true", () => {
    api.rerender('9e6674e6', render)
  })

}


export default __exports__